// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/flexible.css
// module id = 862
// module chunks = 41